import { Group, NumberInput, Select } from "@mantine/core";
import { useUpdateFieldMutation } from "../../hooks/mutations";
import { buildFieldPutData } from "../../utils/conditionField";
import classes from "./Formula.module.scss";

const SIGN_ITEMS = [
  { label: "*", value: "MULTIPLY" },
  { label: "/", value: "DIVIDE" },
  { label: "+", value: "SUM" },
  { label: "-", value: "SUBTRACT" },
];

/**
 * Inline formula editor — composes a sign (* / + -) and a numeric value
 * onto either the left or right side of a condition field.
 */
export default function Formula({
  ruleId,
  fieldsData,
  left = false,
  canEdit = true,
  leadingSlot,
}) {
  const { mutate: updateField } = useUpdateFieldMutation({ ruleId });

  const value = left
    ? fieldsData?.leftPart?.value
    : fieldsData?.rightPart?.value;
  const sign =
    (left ? fieldsData?.leftPart?.sign : fieldsData?.rightPart?.sign) ||
    "MULTIPLY";

  const save = (newValue, newSign) => {
    const putData = { ...buildFieldPutData(fieldsData) };
    if (left) {
      putData.leftValue = newValue;
      putData.leftSign = newSign || "MULTIPLY";
    } else {
      putData.value = newValue;
      putData.sign = newSign || "MULTIPLY";
    }
    updateField(putData);
  };

  return (
    <Group gap={10} align="flex-end" wrap="nowrap" w="100%">
      {leadingSlot}
      <Select
        data={SIGN_ITEMS}
        value={sign}
        onChange={(v) => save(value, v)}
        disabled={!canEdit}
        variant="unstyled"
        w={80}
        allowDeselect={false}
        className={classes.formulaField}
      />
      <NumberInput
        defaultValue={value != null && sign ? Number(value) : undefined}
        disabled={!canEdit}
        variant="unstyled"
        hideControls
        className={classes.formulaField}
        onBlur={(ev) => {
          const next = ev.currentTarget.value;
          save(next === "" ? null : Number(next), sign);
        }}
      />
    </Group>
  );
}
